import Vue from "vue";
import VeeValidate from "vee-validate";

const VueValidationEs = require("vee-validate/dist/locale/es");
const VueValidationFr = require("vee-validate/dist/locale/fr");
Vue.use(VeeValidate, {
  locale: "es",
  dictionary: {
    es: VueValidationEs,
    fr: VueValidationFr
  }
});
